import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ButtonComponent } from '../../common/components/button/button.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { AdminService } from '../../../services/admin.service';
import { EditUserDialogComponent } from './dialogs/edit-user-dialog/edit-user-dialog.component';
import { ChangeRoleDialogComponent } from './dialogs/change-role-dialog/change-role-dialog.component';
import { ChangeStatusDialogComponent } from './dialogs/change-status-dialog/change-status-dialog.component';
import { ActiveDeactiveUserDialogComponent } from './dialogs/active-deactive-user-dialog/active-deactive-user-dialog.component';
import { ErrorNotficationComponent } from '../../../error-notfication/error-notfication.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoaderComponent } from '../../common/components/loader/loader.component';
import { DateWithTimeFormatterPipe } from '../../common/pipes/date-with-time-formatter.pipe';

@Component({
  selector: 'app-user-management',
  standalone: true,
  imports: [MatButtonModule, ButtonComponent, MatCardModule, MatFormFieldModule, MatInputModule, FormsModule,CommonModule,MatDialogModule,MatPaginatorModule, MatSortModule, MatSelectModule,NgMultiSelectDropDownModule, MatTableModule, MatCheckboxModule, MatTooltipModule, LoaderComponent, DateWithTimeFormatterPipe],
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss'
})
export class UserManagementComponent implements OnInit, AfterViewInit {

  dropdownSettings: IDropdownSettings = {};
  roleDropdownList: any = [];
  categoryDropdownList: any = [];
  statusDropdownList: any = [];
  selectedRoles: any;
  selectedCategory: any;
  selectedStatus: any;
  allUsersList: any;
  filteredUsers: any;
  isSelectedAllUsers: boolean = false;
  totalRecords: any = 0;
  pageSize: number = 20;
  pageIndex: number = 0;
  pageSizeOptions: number[] = [5, 10, 20];
  pageNumbers: number[] = [];
  isLoading: boolean = false;
  loggedUserId: any;
  
  isToggleObj: any = {
    isRoleDropdown: false,
    isCategoryDropdown: false,
    isStatusDropdown: false
  }

  isPopupVisible = false;

  categoriesList: any;
  rolesList: any = [
    {
      role_id: 1, role_name: 'admin'
    },
    {
      role_id: 3, role_name: 'creator'
    },
    {
      role_id: 2, role_name: 'curator'
    },
    {
      role_id: 4, role_name: 'user'
    }
    
  ];

  statusList: any = [
    { item_id: 1, item_text: 'Active' },
    { item_id: 2, item_text: 'Inactive' },
  ];

  selectedRoleItems: any = [];
  selectedCategoryItems: any = [];
  selectedStatusItems: any = [];

  // for the get api filters call
  role: any;
  category: any;
  status: any;

  // sorting variables
  userNameAscSort: boolean = true;
  userNameDesSort: boolean = true;

  roleAscSort: boolean = true;
  roleDesSort: boolean = true;

  catAscSort: boolean = true;
  catDesSort: boolean = true;

  statusAscSort: boolean = true;
  statusDesSort: boolean = true;

  lastLoginAscSort: boolean = true;
  lastLoginDesSort: boolean = true;

  // first load api not called api multiple times
  isFirstLoad: any = {
    isRoleFirstLoad: true,
    isCategoryFirstLoad: true,
    isStatusFirstLoad: true,
  }

  sort_by: string = '';
  order: string = '';
  search_text: string = '';

  searchtextData: string = '';

  @ViewChild(MatSort) sort: MatSort = {} as MatSort; // MatSort for sorting
  @ViewChild(MatPaginator) paginator: MatPaginator = {} as MatPaginator;

  displayedColumns: string[] = ['select', 'username', 'role_name', 'category_names_str', 'last_login', 'active', 'action'];
  dataSource = new MatTableDataSource<any>();
  // selection! : SelectionModel<any>;
  selection = new SelectionModel<any>(true, []);

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  constructor(
    private adminService: AdminService,
    private dialog: MatDialog,
  ){}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
    this.getAllCategories();
    this.getAllUsers();
  }

  onPageChange(event: any) {
  
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getAllUsers();
  }

  onPageChangeFromDropdown(event: any) {
    this.pageIndex = event.value;
    this.getAllUsers();
  }

  searchData(data:any) {
    if(data == '') {
      return
    } else {
      this.search_text = data;
      this.pageIndex = 0;
      this.getAllUsers();
    }
  }

  onSearchChange() {
    if (this.searchtextData == '') {
      this.search_text = '';
      this.getAllUsers();
    }
  }

  getAllUsers(filterData?:any) {
    const params: any = {
      skip: (this.pageSize * this.pageIndex),
      limit: this.pageSize,
      category: this.category ? this.category : null,
      status: this.status ? this.status : null,
      role: this.role ? this.role : null,
      sort_by: this.sort_by != '' ? this.sort_by : null,
      order: this.order != '' ? this.order : null,
      search_text: this.search_text != '' ? this.search_text : null
    };
    if(params.role == null) {
      delete params.role
    }
    if(params.category == null) {
      delete params.category
    }
    if(params.status == null) {
      delete params.status
    }
    if(params.sort_by == null) {
      delete params.sort_by
    }
    if(params.order == null) {
      delete params.order
    }
    if(params.search_text == null) {
      delete params.search_text
    }
    this.isLoading = true;
    this.adminService.getAllUsers(params).subscribe((resp:any) => {
      this.isLoading = false;
 
      this.isPopupVisible = false;
      this.selection = new SelectionModel<any>(true, []);
      this.allUsersList = resp?.data?.users;
      this.totalRecords = resp?.data?.total;
      const totalPages = Math.ceil(this.totalRecords / this.pageSize);
      this.pageNumbers = Array.from({ length: totalPages }, (_, i) => i);

   
      
      this.allUsersList.map((item:any) => {
        const categoryNames = item.user_category.map((category:any) => category.name);
        item.category_names = [...categoryNames];
        item.category_names_str = categoryNames.toString();
      });
      

      this.dataSource.data = JSON.parse(JSON.stringify(this.allUsersList));
      // this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      
      // this.selection = new SelectionModel(true);

      // this.setPaginatorAndSort();

      // this.roleDropdownList = resp.data.users.map((item: any) => ({
      //   item_id: item.role_id,
      //   item_text: item.role_name
      // })).filter((value: any, index: any, self: any) =>
      //   index === self.findIndex((t: any) => (
      //     t.item_id === value.item_id && t.item_text === value.item_text
      //   ))
      // );

      this.roleDropdownList = this.rolesList.map((item: any) => ({
        item_id: item.role_id,
        item_text: item.role_name.charAt(0).toUpperCase() + item.role_name.slice(1)
      })).filter((value: any, index: any, self: any) =>
        index === self.findIndex((t: any) => (
          t.item_text === value.item_text
        ))
      );

      const categories:any = [];
        this.categoriesList?.forEach((category:any) => {
          categories.push({
            item_id: category.id,
            item_text: category.name
        });
      });
  
      // Filter out duplicates
      this.categoryDropdownList = categories.filter((value: any, index: any, self: any) =>
        index === self.findIndex((t: any) => (
          t.item_id === value.item_id && t.item_text === value.item_text
        ))
      );

     
      

      this.statusDropdownList = this.statusList.map((item: any) => ({
        item_id: item.item_id,
        item_text: item.item_text
      })).filter((value: any, index: any, self: any) =>
        index === self.findIndex((t: any) => (
          t.item_text === value.item_text
        ))
      );
    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    })
  }

  getAllCategories() {
    // this.isLoading = true;
    this.adminService.getAllCategories().subscribe((resp:any) => {
      // this.isLoading = false;
      this.categoriesList = resp?.data.filter((item:any) => item.is_active);

    }, (error) => {
      // this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
    });
  }

  getRemainingCategories(categories:string[]) {
    if(categories.length > 1) {
      return categories.slice(1, categories.length + 1).join(', ');
    }
    return '';
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;  // Link paginator
    // this.dataSource.sort = this.sort;  // Link sorting
  }

  filteredUsersList(filterData:any) {
    // this.filteredUsers = this.allUsersList?.filter((record:any) => {
      
    //   const matchesRoles = this.selectedRoleItems.length === 0 || this.selectedRoleItems.some((item:any) => item.item_text === record.role_name);
    //   const matchesCategory = this.selectedCategoryItems.length === 0 || record.user_category.some((cat:any) => this.selectedCategoryItems.some((item:any) => item.item_id === cat.id));

    //   const recordStatus: any = record.active ? "Active" : "Inactive";
    //   const matchesStatus = this.selectedStatusItems.length === 0 || this.selectedStatusItems.some((item:any) => (item.item_text === recordStatus));

    //   return matchesRoles && matchesCategory && matchesStatus;
    // });
    // this.dataSource = new MatTableDataSource(this.filteredUsers);
    // this.setPaginatorAndSort();
    if (filterData) {
      // filterData.
    }
  }

  setPaginatorAndSort(): void {
    // if (this.paginator && this.sort) {
    //   // this.dataSource.paginator = this.paginator;
    //   this.dataSource.sort = this.sort;
    // } else {
    //   console.warn('Paginator or Sort is not yet initialized.');
    // }
  }

  onRoleItemSelect(e:any) {

    if (this.isFirstLoad?.isRoleFirstLoad) {
      this.isFirstLoad.isRoleFirstLoad = false;
      return;
    }
    this.role = e.map((item:any) => item.item_id);
    this.pageIndex = 0;
    this.getAllUsers();
  }

  onCategoryItemSelect(e:any) {
    if (this.isFirstLoad?.isCategoryFirstLoad) {
      this.isFirstLoad.isCategoryFirstLoad = false;
      return;
    }
    this.category = e.map((item:any) => item.item_id);
    this.pageIndex = 0;
    this.getAllUsers();
  }

  onStatusItemSelect(e:any) {
    if (this.isFirstLoad?.isStatusFirstLoad) {
      this.isFirstLoad.isStatusFirstLoad = false;
      return;
    }
    this.status = e.map((item:any) => item.item_text === "Active");
    this.pageIndex = 0;
    this.getAllUsers();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection?.selected?.length;
    const numRows = this.dataSource?.data?.length;
    return numSelected === numRows;
    
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    // if (this.isAllSelected()) {
    //   this.selection.clear();
    //   return;
    // }

    // this.selection.select(...this.dataSource?.data);
    
    
    this.isAllSelected() ? this.selection.clear() : this.dataSource?.data.forEach((row:any) => this.selection.select(row));
    this.checkAndOpenPopup();
  }

  /** The label for the checkbox on the passed row */
  // checkboxLabel(row?:any): string {
  //   if (!row) {
  //     return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
  //   }
  //   return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.username + 1}`;
  // }

  toggleRowSelection(row:any) {
    
    // this.isSelectedAllUsers = true;
    this.selection.toggle(row);
    this.checkAndOpenPopup();
  }

  selectAllUsers() {
    // if (!this.isSelectedAllUsers) {
      this.toggleAllRows();
    //   this.isSelectedAllUsers = false;
    // }
  }
   // Show the floating popup only if at least one row is selected
   checkAndOpenPopup() {
    if (this.selection.selected.length > 0) {
      this.isPopupVisible = true;  // Show popup if any row is selected
    } else {
      this.isPopupVisible = false;  // Hide popup if no rows are selected
    }
  }

  // Close the floating popup
  closeFloatingDialog() {
    this.isPopupVisible = false;  // This will hide the popup
    this.selection.clear();
  }


  editRowSelection(user:any, event: MouseEvent): void {
    event.stopPropagation();
   
    user.categoryDropdownList = this.categoriesList;
    const dialogRef = this.dialog.open(EditUserDialogComponent, {
      data: user,
      maxWidth: '400px',
      width: '100%',
      disableClose: true
    })

    dialogRef.afterClosed().subscribe((dialogResp:any) => {
      
      
      if(dialogResp) {
        // const selectedRows = this.selection.selected;
        // const postData = {
        //   user_ids: selectedRows.map((item:any) => item.id),
        //   category_ids_assign: dialogResp.categories ? dialogResp.categories.map((item:any) => item.id) : [],
        //   category_ids_remove: [],
        //   role_id: selectedRows[0]?.role_id
        // }
        this.isLoading = true;
        this.adminService.updateUserRoleCategory(dialogResp).subscribe((resp:any) => {
          this.isLoading = false;
          if (dialogResp.role_id == 4) {
            const userMsg = `The role has been successfully changed to 'User' for '${user.username}'`;
            this.openSnackbar(userMsg, 'Edit Successfully' , 'success-snackbar');
          } else if (dialogResp.role_id == 3) {
            const creatorMsg = `The role has been successfully changed to 'Creator' for '${user.username}'`
            this.openSnackbar(creatorMsg, 'Edit Successfully' , 'success-snackbar');
          } else if (dialogResp.role_id == 2) {
            const curatorMsg = `The role has been successfully changed to 'Curator' with the selected Categories for '${user.username}'`
            this.openSnackbar(curatorMsg, 'Edit Successfully' , 'success-snackbar');
          } else if (dialogResp.role_id == 1) {
            const adminMsg = `The role has been successfully changed to 'Admin' for '${user.username}'`
            this.openSnackbar(adminMsg, 'Edit Successfully' , 'success-snackbar');
          }
          // this.openSnackbar("Edit user successfully", 'Edit Successfully', 'success-snackbar');
          this.getAllUsers();
        },(error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    })
  }

  changeRole() {
    const dialogRef = this.dialog.open(ChangeRoleDialogComponent, {
      data: this.categoriesList,
      maxWidth: '400px',
      width: '100%',
      disableClose: true
    })

    dialogRef.afterClosed().subscribe((dialogResp:any) => {

    
      
      const selectedRows = this.selection?.selected;
      const roleId = this.getRoleIdByName(dialogResp?.role);
      
      
      if (dialogResp && dialogResp.role) {
        const postData = {
          user_ids: selectedRows.map((item:any) => item?.id),
          category_ids_assign: dialogResp?.categories ? dialogResp?.categories.map((item:any) => item?.id) : [],
          category_ids_remove: [],
          role_id: roleId
        }

       
        
        this.isLoading = true;
        this.adminService.updateUserRoleCategory(postData).subscribe((resp:any) => {
          this.isLoading = false;
          // this.openSnackbar("Role change successfully", 'Role change Successfully', 'success-snackbar');
          if (postData.role_id == 4) {
            const userMsg = `The role has been successfully changed to 'User' for the ${selectedRows?.length} selected users.`;
            this.openSnackbar(userMsg, 'Edit Successfully' , 'success-snackbar');
          } else if (postData.role_id == 3) {
            const creatorMsg = `The role has been successfully changed to 'Creator' for the ${selectedRows?.length} selected users.`
            this.openSnackbar(creatorMsg, 'Edit Successfully' , 'success-snackbar');
          } else if (postData.role_id == 2) {
            const curatorMsg = `The role has been successfully changed to 'Curator' with the selected Categories for the ${selectedRows?.length} selected users.`
            this.openSnackbar(curatorMsg, 'Edit Successfully' , 'success-snackbar');
          } else if (postData.role_id == 1) {
            const adminMsg = `The role has been successfully changed to 'Admin' for the ${selectedRows?.length} selected users.`
            this.openSnackbar(adminMsg, 'Edit Successfully' , 'success-snackbar');
          }
          this.getAllUsers();
        },(error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
      
    })
  }

  getRoleIdByName(roleName: string): number | null {
    const role = this.rolesList.find((role:any) => role.role_name === roleName);
    return role ? role.role_id : null; // Return the ID if the role is found, else return null
  }

  changeStatus() {
    const dialogRef = this.dialog.open(ChangeStatusDialogComponent, {
      // data: user,
      maxWidth: '400px',
      width: '100%',
      disableClose: true
    })
    
    dialogRef.afterClosed().subscribe((dialogResp:any) => {
    
      if (dialogResp) {
        const selectedRows = this.selection.selected;
        const postData = {
          user_ids: selectedRows.map((item:any) => item.id),
          active: dialogResp === 'Active' ? true : false
        }
       

        this.isLoading = true;
        this.adminService.updateUserStatus(postData).subscribe((resp:any) => {
          this.isLoading = false;
          this.getAllUsers();
          // this.openSnackbar("Status change successfully", 'Status change Successfully', 'success-snackbar');
          if (postData.active) {
            this.openSnackbar(`Status activated successfully for ${postData?.user_ids?.length} selected users.`, 'Activated Successfully', 'success-snackbar');
          } else if (!postData.active) {
            this.openSnackbar(`Status deactivated successfully for ${postData?.user_ids?.length} selected users.`, 'Deactivated Successfully', 'success-snackbar');
          }
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    })
  }
  
  activeDeactiveRowSelection(user:any, event: MouseEvent): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(ActiveDeactiveUserDialogComponent, {
      data: user,
      maxWidth: '400px',
      width: '100%',
      disableClose: true
    })

    dialogRef.afterClosed().subscribe((dialogResp:any) => {
      if (dialogResp) {
        const postData = {
          user_ids: [dialogResp.id],
          active: dialogResp.active
        }
       

        this.isLoading = true;
        this.adminService.updateUserStatus(postData).subscribe((resp:any) => {
          this.isLoading = false;
          this.getAllUsers();
          
          
          if (dialogResp.active) {
            this.openSnackbar(`Status activated successfully for ${user?.username}`, 'Activated Successfully', 'success-snackbar');
          } else if (!dialogResp.active) {
            this.openSnackbar(`Status deactivated successfully for ${user?.username}`, 'Deactivated Successfully', 'success-snackbar');
          }
        }, (error) => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
        })
      }
    });
  }

  openSnackbar(message: string, title: string, cssClass: string) {
    const dialogRef = this.dialog.open(ErrorNotficationComponent, {
      data: {
        message: message,
        title: title,
        action_type: 'add',
        cssClass: cssClass
      }
    });
  }

  downloadUserList() {
    let downloadUrl = this.adminService.downloadAllUsers();

    this.loggedUserId = localStorage.getItem("user_id");
    // for different window open
    // window.open(downloadUrl, '_blank')

    //for same page download 

    const params = new URLSearchParams();
    if (this.role && Array.isArray(this.role) && this.role.length > 0) {
      this.role.forEach((role:any) => params.append('role', role));
    } else if (this.role && !Array.isArray(this.role) && this.role !== '') {
      params.set('role', this.role);
    }
    
    if (this.category && Array.isArray(this.category) && this.category.length > 0) {
      this.category.forEach((cat:any) => params.append('category', cat));
    } else if (this.category && !Array.isArray(this.category) && this.category !== '') {
      params.set('category', this.category);
    }
    
    if (this.status && Array.isArray(this.status) && this.status.length > 0) {
      this.status.forEach((status:any) => params.append('status', status));
    } else if (this.status && !Array.isArray(this.status) && this.status !== '') {
      params.set('status', this.status);
    }

    if (this.search_text && this.search_text !== '') {
      params.set('search_text', this.search_text);
    }

    params.set('admin_user_id', this.loggedUserId);

    const urlWithParams = `${downloadUrl}?${params.toString()}`;
    
    this.adminService.getDownloadAllUsers(urlWithParams).subscribe((blob: Blob) => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
     
      a.href = objectUrl;
      a.download = 'user.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }, error => {
      console.error('Download failed', error);
    });
  }

  toggleDropdownState(toggle:any) {
    this.isToggleObj[toggle] = !this.isToggleObj[toggle];
  }
  handleOutsideClick(event: MouseEvent, id: any) {
    const dropdownContainer = document.querySelector('.custom-multi-dropdown-container.dropdown-list');
    if (dropdownContainer) {
      this.isToggleObj = {
        isRoleDropdown: false,
        isCategoryDropdown: false,
        isStatusDropdown: false
      }
    }
  }
  clearSearch() {
    if (this.searchInput) {
      // this.searchInput.nativeElement.value = '';
      this.searchtextData = '';
      this.search_text = '';
      this.pageIndex = 0;
      this.getAllUsers();
      // this.dataSource.filter = '';
    }
  }

  sortingByAsc(sortColumn:any) {
    this.pageIndex = 0;
    if (sortColumn == 'usernameSort') {
      this.userNameAscSort = false;
      this.userNameDesSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.statusAscSort = true;
      this.statusDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'username';
      this.order = 'asc';
      this.getAllUsers();
    }
    else if (sortColumn == 'roleSort') {
      this.roleAscSort = false;
      this.roleDesSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.statusAscSort = true;
      this.statusDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'role';
      this.order = 'asc';
      this.getAllUsers();
    }
    else if (sortColumn == 'catSort') {
      this.catAscSort = false;
      this.catDesSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.statusAscSort = true;
      this.statusDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'category';
      this.order = 'asc';
      this.getAllUsers();
    }
    else if (sortColumn == 'statusSort') {
      this.statusAscSort = false;
      this.statusDesSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'status';
      this.order = 'asc';
      this.getAllUsers();
    }
    else if (sortColumn == 'lastLoginSort') {
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = false;
      this.statusDesSort = true;
      this.statusAscSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.sort_by = 'last_login';
      this.order = 'asc';
      this.getAllUsers();
    }
  }

  sortingByDes(sortColumn:any) {
    this.pageIndex = 0;
    if (sortColumn == 'usernameSort') {
      this.userNameDesSort = false;
      this.userNameAscSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.statusAscSort = true;
      this.statusDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'username';
      this.order = 'desc';
      this.getAllUsers();
    }
    else if (sortColumn == 'roleSort') {
      this.roleDesSort = false;
      this.roleAscSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.statusAscSort = true;
      this.statusDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'role';
      this.order = 'desc';
      this.getAllUsers();
    }
    else if (sortColumn == 'catSort') {
      this.catDesSort = false;
      this.catAscSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.statusAscSort = true;
      this.statusDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'category';
      this.order = 'desc';
      this.getAllUsers();
    }
    else if (sortColumn == 'statusSort') {
      this.statusDesSort = false;
      this.statusAscSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.lastLoginDesSort = true;
      this.lastLoginAscSort = true;
      this.sort_by = 'status';
      this.order = 'desc';
      this.getAllUsers();
    }
    else if (sortColumn == 'lastLoginSort') {
      this.lastLoginDesSort = false;
      this.lastLoginAscSort = true;
      this.statusDesSort = true;
      this.statusAscSort = true;
      this.catAscSort = true;
      this.catDesSort = true;
      this.roleAscSort = true;
      this.roleDesSort = true;
      this.userNameAscSort = true;
      this.userNameDesSort = true;
      this.sort_by = 'last_login';
      this.order = 'desc';
      this.getAllUsers();
    }
  }
}
